export default __webpack_public_path__ + "static/icon-13-2-b2c79e25ac9c439b77f79ec05b5c3de6.png";